var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lane") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.007,294.154c0-48.641-39.572-88.213-88.214-88.213c-48.641,0-88.212,39.572-88.212,88.213   c0,14.254,3.401,27.727,9.431,39.654l78.781,162.464l78.795-162.489C237.609,321.861,241.007,308.397,241.007,294.154z    M152.793,342.971c-26.917,0-48.817-21.9-48.817-48.817s21.9-48.817,48.817-48.817c26.918,0,48.817,21.9,48.817,48.817   S179.711,342.971,152.793,342.971z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.75,15.728c-24.63,0-44.669,20.038-44.669,44.668c0,7.218,1.723,14.04,4.776,20.081l39.893,82.267l39.899-82.28   c3.049-6.037,4.77-12.855,4.77-20.067C447.419,35.766,427.379,15.728,402.75,15.728z M402.75,85.116   c-13.631,0-24.72-11.089-24.72-24.72c0-13.63,11.089-24.72,24.72-24.72c13.629,0,24.719,11.09,24.719,24.72   C427.469,74.027,416.379,85.116,402.75,85.116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.845,305.515c-1.813-8.524-4.166-16.875-7.131-25.075c-3.974-10.988-8.74-21.724-12.391-32.836   c-6.823-20.771,4.948-38.105,7.16-41.256c3.876-5.517,8.409-10.58,13.191-15.322c9.207-9.128,19.361-17.288,29.984-24.803   c-1.316-2.039-2.591-4.1-3.805-6.199c-15.279,5.99-93.853,33.452-91.937,94.121c0.384,12.162,5.083,23.738,7.979,35.527   c1.395,5.68,2.606,11.411,3.345,17.217c0.32,2.615,0.515,5.244,0.73,7.871c0.006-0.02,0.004-0.035-0.008-0.046   c0.007,0.077,0.202,8.327-0.164,11.901c-1.148,11.189-2.799,22.494-7.516,32.757c-4.386,9.544-11.005,17.843-19.193,24.403   c-18.716,14.994-43.514,20.988-66.913,23.399c-1.114,0.116-2.228,0.216-3.342,0.313l-41.779,86.154   c20.614-1.283,41.175-4.103,61.235-9.039c23.607-5.811,46.613-14.589,67.226-27.598c20.596-12.997,38.308-30.578,50.099-51.984   c12.335-22.392,17.278-48.039,16.225-73.453C366.48,322.885,365.656,314.034,363.845,305.515z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanes);
export default __webpack_public_path__ + "static/media/lanes.fa7d390fe7679c1643ee535717df8dd6.svg";
export { ForwardRef as ReactComponent };